import { useInfiniteQuery, type InfiniteData } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { GetListarImobiliariasCorretoresService } from '@/features/proposta/brasil/http/get-imobiliarias-corretores.service'
import type {
  TGetListaDeImobiliariasCorretoresParams,
  TGetListaDeImobiliariasCorretoresResponse,
} from '@/features/proposta/brasil/types/imobiliarias.types'
import { propostaKeys } from '@/features/proposta/brasil/utils'

const CINCO_MINUTOS = 5 * 60 * 1000

export const useListarImobiliariasCorretores = (query: Partial<TGetListaDeImobiliariasCorretoresParams>) =>
  useInfiniteQuery<
    TGetListaDeImobiliariasCorretoresResponse,
    AxiosError,
    InfiniteData<TGetListaDeImobiliariasCorretoresResponse>,
    ReturnType<typeof propostaKeys.listaImobiliariasCorretores>,
    number
  >({
    retry: false,
    queryKey: propostaKeys.listaImobiliariasCorretores(query),
    queryFn: ({ pageParam }) =>
      new GetListarImobiliariasCorretoresService()
        .execute({ paginaCorrente: pageParam, ...query })
        .then((res) => res.data),
    initialPageParam: 1,
    getNextPageParam: ({ metadata: { paginaCorrente, totalDePaginas } }, todasPaginas) =>
      totalDePaginas > paginaCorrente ? todasPaginas.length + 1 : undefined,
    staleTime: CINCO_MINUTOS,
  })
